'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Angelcam = undefined;

var _player = require('overrides/clappr/components/player');

var _player2 = _interopRequireDefault(_player);

var _events = require('overrides/clappr/base/events');

var _events2 = _interopRequireDefault(_events);

var _recording = require('./recording');

var _recording2 = _interopRequireDefault(_recording);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Angelcam = {
    Player: _player2.default,
    Events: _events2.default,
    RecordingPlugin: _recording2.default
};

exports.Angelcam = Angelcam;


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/main.js
// module id = 130
// module chunks = 0